<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import countTo from "vue-count-to";
import axios from "axios";

export default {
  components: { Layout, countTo },
  page: {
    title: "Hasil Ujian",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Hasil Ujian",
      breadcrumbs: [
        { text: "Dashboard", href: "/" },
        { text: "Student", href: "/student" },
        { text: "Hasil", active: true },
      ],
      setParamsId: this.$route.params.id,
      dataFinish: [],
      isLoading: true,
      testLulus: false,
      nilai: null,
    };
  },
  computed: {
    resultMessage() {
      if (!this.testLulus) {
        return {
          title: "Tetap Semangat!",
          message: `Nilai kamu belum mencapai KKM ${
            this.dataFinish.soal.paket === "Test Kecermatan"
              ? this.dataFinish.hasil.start_lulus
              : this.dataFinish.soal.kkm
          }. Jangan menyerah, kamu pasti bisa!`,
          icon: "💪",
          class: "result-card warning",
        };
      }
      return {
        title: "Luar Biasa!",
        message: `Kamu berhasil lulus ${this.dataFinish.soal.paket} dengan nilai membanggakan!`,
        icon: "🌟",
        class: "result-card success",
      };
    },
    gradeColor() {
      if (this.nilai >= 90) return "#2ECC71";
      if (this.nilai >= 80) return "#3498DB";
      if (this.nilai >= 70) return "#F1C40F";
      return "#E74C3C";
    },
  },
  mounted() {
    this.getHasilUjian();
  },
  methods: {
    async getHasilUjian() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/api/json/ujian/${this.setParamsId}/finish`
        );
        this.dataFinish = response.data;

        if (this.dataFinish.soal.paket === "Test Kecermatan") {
          this.nilai = parseFloat(this.dataFinish.hasil.nilai_konversi);
          this.testLulus =
            parseInt(this.nilai) >= parseInt(this.dataFinish.hasil.start_lulus);
        } else {
          this.nilai = parseFloat(this.dataFinish.hasil.jumlah_nilai);
          this.testLulus =
            parseInt(this.nilai) >= parseInt(this.dataFinish.soal.kkm);
        }
      } catch (error) {
        console.error("Error fetching results:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <div class="results-container">
      <div v-if="isLoading" class="loading-screen">
        <div class="loading-circle"></div>
        <p class="loading-text">Sedang Memuat Data...</p>
      </div>

      <div v-else class="result-content">
        <div class="grade-section">
          <div class="grade-circle" :style="{ '--grade-color': gradeColor }">
            <div class="grade-inner">
              <countTo
                class="grade-number"
                :startVal="0"
                :endVal="nilai"
                :duration="2500"
                :options="{
                  useEasing: true,
                  useGrouping: true,
                  separator: ',',
                  decimal: '.',
                }"
              />
              <span class="grade-label">Nilai Akhir</span>
            </div>
          </div>
        </div>

        <div :class="resultMessage.class">
          <div class="result-icon">{{ resultMessage.icon }}</div>
          <h3 class="result-title">{{ resultMessage.title }}</h3>
          <p class="result-message">{{ resultMessage.message }}</p>
        </div>

        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-content">
              <div class="stat-icon">📊</div>
              <div class="stat-info">
                <div class="stat-label">KKM</div>
                <div class="stat-value">
                  {{
                    dataFinish.soal.paket === "Test Kecermatan"
                      ? dataFinish.hasil.start_lulus
                      : dataFinish.soal.kkm
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-content">
              <div class="stat-icon">📝</div>
              <div class="stat-info">
                <div class="stat-label">Paket Soal</div>
                <div class="stat-value">
                  {{ dataFinish.soal.paket.replace("Test ", "") }}
                </div>
              </div>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-content">
              <div class="stat-icon">{{ testLulus ? "✅" : "❌" }}</div>
              <div class="stat-info">
                <div class="stat-label">Status</div>
                <div class="stat-value">
                  {{ testLulus ? "Lulus" : "Belum Lulus" }}
                </div>
              </div>
            </div>
          </div>

          <template v-if="dataFinish.soal.paket.includes('Test Kecermatan')">
            <div class="stat-card">
              <div class="stat-content">
                <div class="stat-icon">📝</div>
                <div class="stat-info">
                  <div class="stat-label">Jumlah Soal</div>
                  <div class="stat-value">
                    {{ dataFinish.hasil.jumlah_soal }}
                  </div>
                </div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-content">
                <div class="stat-icon">✔️</div>
                <div class="stat-info">
                  <div class="stat-label">Jumlah Benar</div>
                  <div class="stat-value">
                    {{ dataFinish.hasil.total_benar }}
                  </div>
                </div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-content">
                <div class="stat-icon">{{ testLulus ? "✅" : "❌" }}</div>
                <div class="stat-info">
                  <div class="stat-label">Jumlah Salah</div>
                  <div class="stat-value">
                    {{
                      dataFinish.hasil.jumlah_soal -
                        dataFinish.hasil.total_benar
                    }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="action-buttons">
          <button class="btn-home" @click="$router.push('/')">
            <span class="btn-icon">🏠</span>
            <span class="btn-text">Kembali ke Beranda</span>
          </button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.results-container {
  min-height: 100vh;
}

.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.loading-circle {
  width: 48px;
  height: 48px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #4f46e5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 1rem;
  font-size: 1rem;
  color: #666;
}

.result-content {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 1rem;
  animation: fadeUp 0.8s ease-out;
}

.grade-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.grade-circle {
  width: min(180px, 80vw);
  height: min(180px, 80vw);
  border-radius: 50%;
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.grade-circle::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: conic-gradient(
    var(--grade-color) calc(var(--number) * 1%),
    #f0f0f0 calc(var(--number) * 1%)
  );
  mask: radial-gradient(transparent 65%, black 66%);
  -webkit-mask: radial-gradient(transparent 65%, black 66%);
}

.grade-inner {
  text-align: center;
  z-index: 1;
}

.grade-number {
  font-size: clamp(2rem, 8vw, 4rem);
  font-weight: 700;
  color: var(--grade-color);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.grade-label {
  display: block;
  font-size: clamp(0.9rem, 3vw, 1.2rem);
  color: #666;
  margin-top: 0.5rem;
}

.result-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  text-align: center;
  margin: 1.5rem 0;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(0);
  transition: transform 0.3s ease;
}

.result-card.success {
  background: linear-gradient(135deg, #43cea2 0%, #185a9d 100%);
  color: white;
}

.result-card.warning {
  background: linear-gradient(135deg, #f2994a 0%, #f2c94c 100%);
  color: white;
}

.result-icon {
  font-size: clamp(2rem, 6vw, 3rem);
  margin-bottom: 0.75rem;
}

.result-title {
  font-size: clamp(1.4rem, 4vw, 1.8rem);
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.result-message {
  font-size: clamp(1rem, 3vw, 1.2rem);
  line-height: 1.6;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin: 1.5rem 0;
}

.stat-card {
  background: white;
  padding: 1.25rem;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
}

.stat-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.stat-icon {
  font-size: 1.75rem;
  flex-shrink: 0;
}

.stat-info {
  flex-grow: 1;
  text-align: left;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.stat-value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  word-break: break-word;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.btn-home,
.btn-scores {
  width: 100%;
  padding: 0.875rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-home {
  background: #f8f9fa;
  color: #333;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn-scores {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(79, 70, 229, 0.3);
}

.btn-icon {
  font-size: 1.1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 768px) {
  .results-container {
    padding: 2rem;
  }

  .result-content {
    padding: 2rem;
  }

  .action-buttons {
    flex-direction: row;
  }

  .btn-home,
  .btn-scores {
    width: 100%;
    padding: 1rem 2rem;
  }

  .stat-card {
    padding: 1.5rem;
  }

  .stat-value {
    font-size: 1.4rem;
  }

  .result-card {
    padding: 2rem;
    border-radius: 20px;
  }

  .grade-circle {
    width: min(280px, 80vw);
    height: min(280px, 80vw);
  }
}
</style>
